import { Children, isValidElement, type ReactElement, type ReactNode } from "react";

export const hentTekstFraChildren = (children: ReactNode): string | undefined => {
	if (!children) {
		return;
	}
	if (typeof children === "string") {
		return children;
	}
	if (typeof children === "number") {
		return String(children);
	}
	if (isValidElement(children)) {
		const element = children as ReactElement<{ children?: ReactNode }>;
		const childType = element.type;
		if (typeof childType === "function") {
			try {
				const result = (childType as () => ReactNode)();
				if (typeof result === "string") {
					return result;
				}
			} catch {
				// Component requires props or has side effects, skip extraction
			}
		}
		// Recurse into the element's own children (e.g. <span>tekst</span>)
		if (element.props?.children != null) {
			return hentTekstFraChildren(element.props.children);
		}
	}
	if (Array.isArray(children)) {
		const texts = Children.toArray(children).map(hentTekstFraChildren).filter(Boolean);
		return texts.length > 0 ? texts.join(" ") : undefined;
	}
	return undefined;
};
